import { defineMessages, useIntl } from 'react-intl';
const messages = defineMessages({
    title: {
        description: 'Title for the model upsell popover',
        defaultMessage: 'Access the top AI models',
        id: '216cf3ce25',
    },
    authDescription: {
        description: 'Description for model upsell when user is not logged in',
        defaultMessage: 'Access the latest AI models from OpenAI, Anthropic (Claude) and more',
        id: '5f4f24a72b',
    },
    maxRequiredDescription: {
        description: 'Description for model upsell when user needs a higher plan tier',
        defaultMessage: 'Upgrade to access the most powerful AI models',
        id: 'ea097e3820',
    },
    subscriptionDescription: {
        description: 'Description for model upsell when user needs a subscription',
        defaultMessage: 'Upgrade to access the latest AI models from OpenAI, Anthropic (Claude) and more',
        id: '765d152b6c',
    },
});
function getUpsellContentConfig(gateReason) {
    switch (gateReason) {
        case 'auth':
            return { descriptionMessage: messages.authDescription, requiredTier: 'pro' };
        case 'max_required':
            return { descriptionMessage: messages.maxRequiredDescription, requiredTier: 'max' };
        case 'subscription':
            return { descriptionMessage: messages.subscriptionDescription, requiredTier: 'pro' };
    }
}
export function useAskInputModelUpsellContent({ gateReason }) {
    const { $t } = useIntl();
    const { descriptionMessage, requiredTier } = getUpsellContentConfig(gateReason);
    return {
        title: $t(messages.title),
        description: $t(descriptionMessage),
        requiredTier,
    };
}
//# sourceMappingURL=AskInputModelUpsellPopover.js.map